// extracted by mini-css-extract-plugin
export default {"container":"ResetPassword_container__UicPr","form":"ResetPassword_form__ZquUI","header":"ResetPassword_header__12u8Q"};